<template>
  <div>
    <header
      class="text-primary black l-s-0.175 m-b-80"
    >
      <h2
        class="f-s-54 l-h-65 m-b-7"
      >
        {{ service.routeName }}
      </h2>
      <h4
        class="f-w-600 f-s-24 l-h-29"
      >
        {{ service.subtitle }}
      </h4>
    </header>
    <Paragraph
      :paragraph="service.desc.p1"
      p-item-distance
    />
    <img
      :src="service.imgSrc"
      alt="Fluid image"
      class="m-t-87 m-b-87"
    >
    <Paragraph
      :paragraph="service.desc.p2"
      p-distance
    />
    <Paragraph
      :paragraph="service.desc.p3"
      p-distance
    />
    <Paragraph
      :paragraph="service.desc.p4"
      p-distance
    />
    <Paragraph
      :paragraph="service.desc.p5"
      p-distance
    />
    <Paragraph
      :paragraph="service.desc.p6"
      p-item-distance
      p-distance
    />
  </div>
</template>

<script>
import Paragraph from '@/components/Paragraph';

export default {
  name: 'RegulatoryAffairs',
  components: {
    Paragraph,
  },
  props: {
    service: {
      type: Object,
      default: null,
    },
    serviceDesc: {
      type: Object,
      default: null,
    },
  },
};
</script>
